import React, { useRef, useState } from "react";
import { Button, Card, Input } from "../ui";
import content from "../../services/api-content";
import { useToast } from "../../context/ToastContext";
import { normMedia } from "./PostCard";

/** สร้างโพสต์ (type=post: ข้อความ+รูป) หรือคลิปสั้น (type=short: ลิงก์วิดีโอ https) */
export default function PostComposer({ type = "post", onPosted, collapsed = false }) {
  const toast = useToast();
  const [open, setOpen] = useState(!collapsed);
  const [text, setText] = useState("");
  const [media, setMedia] = useState([]);
  const [videoUrl, setVideoUrl] = useState("");
  const [visibility, setVisibility] = useState("public");
  const [busy, setBusy] = useState(false);
  const fileRef = useRef(null);

  const addImage = async (file) => {
    if (!file) return;
    setBusy(true);
    try { const r = await content.upload(file, "post"); setMedia((m) => [...m, { type: "image", url: r.url }].slice(0, 4)); } catch (e) { toast(e.message, "error"); } finally { setBusy(false); if (fileRef.current) fileRef.current.value = ""; }
  };
  const addVideo = () => {
    const u = videoUrl.trim();
    if (!/^https:\/\//i.test(u)) return toast("ลิงก์วิดีโอต้องขึ้นต้นด้วย https://", "error");
    const m = normMedia({ type: "video", url: u });
    if (!m) return toast("ลิงก์ไม่ถูกต้อง", "error");
    setMedia((l) => [...l, m].slice(0, 4));
    setVideoUrl("");
  };
  const submit = async () => {
    setBusy(true);
    try {
      const post = await content.posts.add({ type, text: text.trim(), media, characterIds: [], visibility });
      setText(""); setMedia([]);
      toast(type === "short" ? "โพสต์คลิปสั้นแล้ว" : "โพสต์แล้ว", "success");
      onPosted?.(post);
      if (collapsed) setOpen(false);
    } catch (e) { toast(e.message, "error"); } finally { setBusy(false); }
  };
  if (!open) return <Button block onClick={() => setOpen(true)}>{type === "short" ? "+ เพิ่มคลิปสั้น" : "+ เขียนโพสต์"}</Button>;
  return (
    <Card>
      <Input multiline maxLength={2000} aria-label="ข้อความโพสต์" placeholder={type === "short" ? "คำบรรยายคลิป..." : "วันนี้อยากเล่าอะไร..."} value={text} onChange={(e) => setText(e.target.value)} hint={`${text.length}/2000`} />
      {media.length ? <div className="chip-row" style={{ marginBottom: 12 }}>{media.map((m) => <span key={m.url} className="chip chip--sm">{m.type === "video" ? "🎬 วิดีโอ" : "🖼️ รูป"}<button type="button" className="act" style={{ minHeight: 20, padding: 0 }} aria-label="เอาออก" onClick={() => setMedia((l) => l.filter((x) => x !== m))}>✕</button></span>)}</div> : null}
      {type === "short" ? (
        <div className="row"><div className="grow"><Input aria-label="ลิงก์วิดีโอ" placeholder="https://.../clip.mp4" value={videoUrl} onChange={(e) => setVideoUrl(e.target.value)} /></div><Button onClick={addVideo} style={{ marginBottom: 14 }}>เพิ่มลิงก์</Button></div>
      ) : (
        <div className="row wrap" style={{ marginBottom: 12 }}>
          <input ref={fileRef} type="file" accept="image/jpeg,image/png,image/gif,image/webp" hidden onChange={(e) => addImage(e.target.files?.[0])} />
          <Button size="sm" onClick={() => fileRef.current?.click()} disabled={busy || media.length >= 4}>🖼️ เพิ่มรูป</Button>
          <span className="faint" style={{ fontSize: 12 }}>สูงสุด 4 รูป</span>
        </div>
      )}
      <div className="row-between wrap">
        <select className="field__control" style={{ width: "auto" }} aria-label="การมองเห็น" value={visibility} onChange={(e) => setVisibility(e.target.value)}>
          <option value="public">สาธารณะ</option><option value="private">ส่วนตัว</option>
        </select>
        <div className="row">{collapsed ? <Button variant="ghost" onClick={() => setOpen(false)}>ยกเลิก</Button> : null}<Button variant="primary" onClick={submit} disabled={busy || (!text.trim() && !media.length)}>{busy ? "กำลังโพสต์..." : "โพสต์"}</Button></div>
      </div>
    </Card>
  );
}
